import { RefiSignOut } from './sign-out.component.js';
import { defineRefiElement } from '../../utils/define-refi-element.js';
import '../../lit-element.js';
import '../../query-assigned-elements.js';
import '../../index2.js';
import '../../icon-sprites.js';
import '../../directive.js';
import '../../unsafe-html.js';
import '../../styles/reset.style.js';
import '../../styles/links.style.js';

defineRefiElement('refi-common-sign-out', RefiSignOut);
